import type { PrismicArticle } from '../../../types';

type ChangelogState = {
  articles: PrismicArticle[];
  isOpen: boolean;
};

type ChangelogActions =
  | {
      type: 'CHANGELOG_RECEIVE';
      articles: PrismicArticle[];
    }
  | { type: 'CHANGELOG_TOGGLE' }
  | { type: 'CHANGELOG_CLOSE' };

const initialState: ChangelogState = {
  articles: [],
  isOpen: false,
};

export default function reducer(
  state = initialState,
  action: ChangelogActions
): ChangelogState {
  if (!state) {
    return {
      ...initialState,
    };
  }

  switch (action.type) {
    case 'CHANGELOG_RECEIVE': {
      return {
        ...state,
        articles: action.articles,
      };
    }

    case 'CHANGELOG_TOGGLE': {
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    }

    case 'CHANGELOG_CLOSE': {
      return {
        ...state,
        isOpen: false,
      };
    }

    default:
  }

  return state;
}
